var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"filterable":true,"options":_vm.options,"custom-label":_vm.label,"placeholder":_vm.placeholder},on:{"input":_vm.handleInput},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }